'use client';

import { usePathname } from 'next/navigation';
import { useRef } from 'react';

import { Button } from 'components/ui/button';
import { Input } from 'components/ui/input';
import { Label } from 'components/ui/label';

import { trackInteraction } from '@/lib/event_tracker';

export default function SubscribeToNewsletter({ className, sessionData }) {
  const userEmail = sessionData.user?.email;
  const pathname = usePathname();
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className={className}>
      <form
        action="https://buttondown.email/api/emails/embed-subscribe/contextualize.ai"
        method="post"
        target="popupwindow"
        onSubmit={(_e) => {
          trackInteraction(sessionData, pathname, 'Newsletter Subscribed To', {
            email: inputRef.current?.value,
          });

          window.open(
            'https://buttondown.email/contextualize.ai',
            'popupwindow'
          );
        }}
        className="flex flex-col space-y-2"
      >
        <Label
          htmlFor="bd-email"
          className="text-lg [text-wrap:balance] sm:text-xl"
        >
          Subscribe to the newsletter to receive cool charts and product updates
        </Label>

        <div className="flex w-full max-w-lg items-center space-x-2">
          <Input
            type="email"
            name="email"
            id="bd-email"
            ref={inputRef}
            placeholder="Type your email..."
            defaultValue={userEmail}
            className="sm:py-6 sm:text-lg"
          />

          <Button type="submit" variant="default" className="sm:p-6 sm:text-xl">
            Subscribe
          </Button>
        </div>
      </form>
    </div>
  );
}
